<template>
  <section v-if="popularData.length">
    <h1 v-if="title">
      {{ title }}
    </h1>
    <swiper :slides-per-view="'auto'" :key="sliderKey">
      <swiper-slide v-for="data in popularData" :key="data.id">
        <RecentlySinglePodcast
          :podcast-data="formattedPodcastData(data)"
          stream-user-progress
          :key="`${data.id}-popular`"
        />
      </swiper-slide>
    </swiper>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import RecentlySinglePodcast from '@/components/common/RecentlySinglePodcast.vue';
import { ref, watch } from 'vue';

import 'swiper/css';

export default {
  name: 'PopularStreamsCarousel',
  components: {
    Swiper,
    SwiperSlide,
    RecentlySinglePodcast,
  },

  props: {
    title: {
      type: String,
      default: null,
    },
    popularData: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const sliderKey = ref(Math.random());

    watch(
      () => [...props.popularData],
      () => {
        sliderKey.value = Math.random();
      },
    );

    const formattedPodcastData = (data) =>
      Object.assign({}, data, { course_media: data.course.media });

    return { sliderKey, formattedPodcastData };
  },
};
</script>

<style scoped lang="scss">
.swiper-slide {
  max-width: 310px !important;
  margin-right: 14px;
}
</style>
